import { CPSConstants } from "commonUtils/enumerations";

export const otpStyle = {
  GridContainer: {
    display: "contents",
  },
  otpInputs: {
    p: "2rem 0rem",
  },
  InLineBox: {
    display: "flex",
    flexDirection: "row",
  },
  BoxSpace: {
    m: "0px 5px",
    fontSize: CPSConstants.FONTREMHEAD,
  },
  BoxSpaceResend: {
    m: "0px 5px",
    fontWeight: "bold",
    fontSize: CPSConstants.FONTREMHEAD,
  },
  GrayOut: {
    color: "gray",
    textDecoration: "none",
  },
  BlueColor: {
    color: "#1976d2",
    textDecoration: "none",
  },
  lbltext:{
    fontWeight: "bold",
    fontSize: CPSConstants.FONTREMHEAD,
  },
};
